import classNames from "classnames/bind";
import useHasMounted from "hooks/useHasMounted/useHasMounted";
import { useEffect, useRef } from "react";
import type { ResolvedInlineFrame } from "resolvers/data/inlineFrameResolver";
import styles from "./InlineFrame.module.scss";

const cx = classNames.bind(styles);

const InlineFrame = (props: ResolvedInlineFrame) => {
    const iframeRef = useRef<HTMLIFrameElement | null>(null);

    return <iframe {...props} ref={iframeRef} className={cx("iframe")}></iframe>;
};

export default InlineFrame;
